import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="163015622468-79fajd2tmftat3qhc1a16nejimm0q28g.apps.googleusercontent.com">
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
);
